import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
// import { BrowserRouter as Router } from "react-router-dom";
import { Router } from "react-router-dom";
import ScrollToTop from "react-router-scroll-top";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga";
import config from "./config";
import Cookies from "universal-cookie";
import { GoogleOAuthProvider } from "@react-oauth/google";

// init Google Analytics
const cookies = new Cookies();
const history = createBrowserHistory();
const username = cookies.get("username");

const sendGaPageView = (location) => {
  // console.log('sendGaPageView location=', location);
  ReactGA.set({ page: location.pathname + location.search });
  ReactGA.pageview(location.pathname + location.search);
};
const initGa = () => {
  ReactGA.initialize(config.GA_TRACKING_ID, {
    // debug: config.ENV === 'dev',
    gaOptions: {
      userId: username,
    },
  });
  sendGaPageView(history.location);
  history.listen(sendGaPageView);
};
initGa();

console.log("index.js googleClientId=", config.GOOGLE_CLIENT_ID);

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID}>
      <Router history={history}>
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </Router>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
